<div class="page-container"
     *ngIf="user; else loadingTemplate">
  <div class="page-title">
    <span [translate]="(authorizedRole | isUserInRole | async) ? 'BUTTON.SETTINGS' : 'ERROR.PERMISSION'"></span>
    <pop-user-card></pop-user-card>
  </div>

  <div class="page-content"
       *ngIf="authorizedRole | isUserInRole | async">
    <div class="settings-tab-box">
      <div class="settings-tab-box"
           *ngIf="licenseAppModule.Estimation | isModuleIncludedInLicense | async">
        <span class="settings-tab-header"
              translate="OPTIONS.ESTIMATIONS"></span>

        <a class="settings-tab"
           routerLink="estimate"
           routerLinkActive="active-settings-tab"
           translate="OPTIONS.GENERAL">
        </a>
        <a class="settings-tab"
           routerLink="estimate-interface"
           routerLinkActive="active-settings-tab"
           translate="OPTIONS.INTERFACE">
        </a>
      </div>
      <span class="settings-tab-header"
            style="padding-top: 13px"
            translate="OPTIONS.SERVICES">
      </span>

      <a class="settings-tab"
         routerLink="license"
         routerLinkActive="active-settings-tab"
         translate="OPTIONS.LICENSES">
      </a>
    </div>
    <div class="settings-management-box">
      <div class="settings-save-box">

        <button class="save-btn"
                [disabled]="isSaving"
                [class.save-disabled]="!ifChanges || isSaving"
                (click)="saveSettings()">
          {{ "BUTTON.SAVE" | translate }}
          <pop-loading *ngIf="isSaving"></pop-loading>
        </button>

        <div class="changes-msg"
             *ngIf="ifChanges"
             translate="OPTIONS.CHANGES">
        </div>
      </div>

      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<ng-template #loadingTemplate>
  <pop-loading>
  </pop-loading>
</ng-template>
